// extracted by css-extract-rspack-plugin
export default {"cls1":"why_free-cls1_bck","cls2":"why_free-cls2_3dB why_free-cls1_bck"};